<template>
  <div class="ctl-evaluate">
    <div class="teacher-info">
      <div class="item">
        <span class="label">陪驾教练</span>
        <span class="value">{{(info.coachName || this.$route.query.coachName) || '—'}}</span>
      </div>
      <div class="item">
        <span class="label">联系电话</span>
        <span class="value">{{(info.coachPhoneNum || this.$route.query.coachMobile) || '—'}}</span>
      </div>
    </div>
    <div class="content-select">
      <div class="cell" v-for="(v,i) in list" :key="i">
        <span class="name">{{v.name}}</span>
        <van-rate :readonly="type === '1'" v-model="formData[v.id]" size="20px" color="#FFAD00" void-color="#FFAD00" allow-half :count="v.allStars"></van-rate>
      </div>
    </div>
    <div class="content-text">
      <span class="name">评价内容</span>
      <van-field
        @click="onFocus"
        class="content-input"
        ref="contentInput"
        v-if="type === '2'"
        v-model="formData.content"
        autosize
        type="textarea"
        maxlength="100"
        placeholder="请输入评价内容…"
        show-word-limit></van-field>
        <div v-else class="content" v-html="formData.content"></div>
    </div>
    <div class="cell" v-if="type === '2'">
      <van-button color="#53CB85" :loading="btnLoading" @click="onSubmit" loading-type="spinner" round block type="primary"><span class="van-button-text">提  交</span></van-button>
    </div>
  </div>
</template>

<script>
import { Rate, Field, Button, Toast } from 'vant'
export default {
    name: 'ctlCourseEvaluate',
    components: {
        // van 输入框组件
        [Field.name]: Field,

        // van 按钮组件
        [Button.name]: Button,

        // van 轻提示框组件
        [Toast.name]: Toast,

        // van 评分组件
        [Rate.name]: Rate
    },
    props: {
        id: {
            type: String,
            default: ''
        },
        // 课程id
        courseId: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            orderId: '',
            list: [],
            info: {},
            paramsInfo: {},
            formData: {
                content: ''
            },
            type: '1',
            // 提交按钮loading
            btnLoading: false

        }
    },
    created () {
        this.orderId = this.$route.query.id
        this.getInfo()
    },
    methods: {
        /**
             * 校验提交数据
             * @returns {Promise<Boolean>}
             */
        checkSubmitData () {
            let data = this.list
            let check = true
            return new Promise((resolve) => {
                for (let v in data) {
                    if (!this.formData[data[v].id]) {
                        Toast.fail(`请选择${data[v].name}！`)
                        check = false
                        break
                    }
                }
                resolve(check)
            })
        },
        onFocus () {
            this.$refs.contentInput.focus()
        },
        // 提交数据
        onSubmit () {
            let data = {
                accompanyOrderId: this.orderId,
                content: this.formData.content,
                listDimension: []
            }

            this.list.forEach(res => {
                data.listDimension.push({
                    dimensionId: res.id,
                    dimensionName: res.name,
                    dimensionScore: this.formData[res.id] * res.eachScore,
                    dimensionStars: this.formData[res.id]
                })
            })

            this.checkSubmitData().then(res => {
                if (res) {
                    this.btnLoading = true
                    this.$api.addEvaluatePeijia(data).then(res => {
                        this.btnLoading = false
                        if (res.status) {
                            Toast.success('评价成功')
                            this.getInfo()
                        }
                    })
                }
            })
        },
        async getInfo () {
            await this.$api.getEvaluateChildListPeijia().then(res => {
                if (res.status) {
                    this.list = res.result
                }
            })

            await this.$api.getEvaluatePeijia({ orderId: this.orderId }).then(res => {
                if (res.status) {
                    this.type = res.result.id ? '1' : '2'
                    this.info = res.result
                    this.info.listDimension && this.info.listDimension.forEach(res => {
                        this.$set(this.formData, res.dimensionId, res.dimensionStars)
                    })
                    this.formData.content = res.result.content
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
  /deep/{
    input,

    textarea {

      -webkit-appearance: none; /* 方法2 */
    }
  }
  .ctl-evaluate{
    overflow: hidden;
    /*覆盖van组件样式 start*/
    /deep/ .van-field{
      padding: 7px 10px;
      border-radius:5px;
      border:1px solid rgba(204,204,204,1);
    }
    /deep/ .van-field__control{
      font:400 13px PingFangSC-Regular,PingFang SC;
      color:rgba(51,51,51,1);
      line-height:24px;
    }
    /deep/.van-field__word-limit{
      font:400 13px PingFangSC-Regular,PingFang SC;
      color:rgba(51,51,51,1);
      line-height:24px;
    }
    /*end*/

    .teacher-info{
      margin: 20px auto 0;
      width: 325px;
      border-bottom: 1px solid #eeeeee;
      .item{
        margin: 0 0 25px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .label{
          display: inline-block;
          font: 500 15px PingFangSC-Medium, PingFang SC;
          color: #333333;
        }
        .value{
          font: 400 15px PingFangSC-Regular, PingFang SC;
          color: #333333;
          max-width: 250px;
          word-break: break-word;
        }
      }
    }

    .content-select{
      width: 325px;
      margin: 24px auto 0;
      border-bottom: 1px solid #eeeeee;
      padding: 0 0 28px 0;
      .van-rate{
        display: flex;
        align-items: center;
      }
    }
    .cell{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 28px 0 0 0;

      &:first-child{
        margin: 20px 0 0 0;
      }
      &.content-text{
        margin: 30px 0 0 0;
      }

      .name{
        font:400 14px PingFangSC-Regular,PingFang SC;
        color: #333333;
      }
    }
    .content-text{
      width: 325px;
      margin: 29px auto 0;

      .name{
        font:400 14px PingFangSC-Regular,PingFang SC;
        color: #333333;
      }

      .content{
        box-sizing: border-box;
        margin: 10px 0 0 0;
        width: 325px;
        padding: 8px;
        background: #FAFAFA;
        font: 400 14px PingFangSC-Regular, PingFang SC;
        color: #333333;
      }
    }

    .content-input{
      margin: 12px 0 0 0;
      height: 150px;
    }

    .van-button-text{
      font:400 17px PingFangSC-Regular,PingFang SC;
      color:rgba(255,255,255,1);
    }

    .van-button{
      width: 345px;
      margin: 0 auto;
    }
  }
</style>
